export default {
	"fe__header__title": {
		"sl": "Rezervacije - Camp Liza",
		"en": "Reservations - Camp Liza",
		"de": "Reservierungen - Camp Liza"
	},
	"fe__header__subtitle": {
		"sl": "Preveri razpoložljivost v Camp Liza Bovec",
		"en": "Check availability in Camp Liza Bovec",
		"de": "Verfügbarkeit prüfen im Camp Liza Bovec"
	},
	"fe__header__subsubtitle": {
		"sl": "Izberite vrsto namestitve, število oseb in obdobje vašega bivanja",
		"en": "Choose Accommodation type, number of people and the period of your staying",
		"de": "Wählen Sie den Unterkunftstyp, die Anzahl der Personen und den Zeitraum Ihres Aufenthalts"
	},
	"fe__header__group_button": {
		"sl": "Skupinska rezervacija",
		"en": "Group booking",
		"de": "Gruppenbuchung"
	},
	"fe__header__group_content": {
		"sl": "<strong>Če želite narediti rezervacijo za kampirno mesto za večjo skupino ljudi, prosimo upoštevajte sledeče:</strong><br /><br /><ol><li>V kolikor bo skupina uporabljala samo eno vrsto namestitve (npr. šotore ali avtodome oz. kamp prikolice) potem ob izbiri vrste namestitve navedite samo skupno število oseb po starosti, kot so navedene v rezervacijskem obrazcu, obdobje namestitve ter izpolnite dodatne informacije in storitve, ki jih potrebujete (električni priključek,...).<br />V kolikor želite, da smatramo takšno rezervacijo kot rezervacijo več nosilcev (plačnikov predplačila), potem navedite ostale nosilce in število oseb pri posameznem nosilcu v opombi pred zaključkom rezervacije.<br /><br /></li><li>V kolikor bo skupina uporabljala različne vrste namestitve (npr. šotor in avtodom oz. kamp prikolico) potem za vsako vrsto namestitve naredite ločeno rezervacijo in navedite število oseb, po starosti, kot so navedene v rezervacijskem obrazcu, obdobje namestitve, ki bodo to vrsto namestitve uporabljale ter izpolnite dodatne informacije in storitve, ki jih potrebujete (električni priključek,...). Enako naredite še za preostale rezervacije.<br />V kolikor želite, da smatramo takšne rezervacije kot rezervacije več nosilcev (plačnikov predplačila), potem navedite ostale nosilce in vrsto namestitve ter število oseb pri posameznem nosilcu v opombi pred zaključkom rezervacije.<br /><br /></li><li>V primeru nejasnosti nam prosim sporočite vaše želje na e-naslov <a href='mailto:booking@camp-liza.com'>booking@camp-liza.com</a> in poslali vam bomo odgovor na vaše povpraševanje.<br /><br /></li></ol>",
		"en": "<strong>If you want to make a reservation for a camping pitch for a larger group of people, please note the following:</strong><br /><br /><ol><li>If the group will use only one type of accommodation (e.g. tents or motorhomes or caravans), then when choosing the type of accommodation, please indicate only the total number of people by age as stated in the booking form, the period of accommodation and fill in additional information and services that you need (electrical connection,...).<br />If you want us to consider such a reservation as a reservation of several reservation holders (advance payment payers), then indicate the other reservation holders and the number of persons with each holders in the note before completing the reservation.<br /><br /></li><li>If the group will use different types of accommodation (e.g. tent and motor home or caravan), then make a separate reservation for each type of accommodation and indicate the number of persons, by age, as stated in the booking form, the period of accommodation, who will use this type of accommodation and fill in the additional information and services you need (electrical connection,...). Do the same for the remaining reservations.<br />If you want us to consider such reservations as reservations of several holders (advance payment payers), then indicate the other reservation holderss and the type of accommodation and the number of people with each holders in the note before completing the reservation.<br /><br /></li><li>In case of ambiguity, please let us know your wishes at the e-mail address <a href='mailto:booking@camp-liza.com'>booking@camp-liza.com</a> and we will send you an answer to your inquiry.</li></ol>",
		"de": "<strong>Wenn Sie einen Campingplatz für eine größere Gruppe reservieren möchten, beachten Sie bitte Folgendes:</strong><br /><br /><ol><li>Wenn die Gruppe nur eine Unterkunftstyp (z.B. Zelte, Wohnmobile oder Wohnwagen) nutzt, geben Sie bei der Auswahl der Unterkunftstyp bitte nur die im Buchungsformular angegebene Gesamtzahl der Personen nach Alter sowie den Zeitraum der Unterkunft an und füllen Sie das Formular aus in zusätzlichen Informationen und Dienstleistungen, die Sie benötigen (Stromanschluss,...).<br />Wenn Sie möchten, dass wir eine solche Reservierung als Reservierung mehrerer Beförderer (Vorauszahler) betrachten, geben Sie vor Abschluss der Reservierung in der Notiz die anderen Beförderer und die Anzahl der Personen bei jedem Beförderer an.<br /><br /></li><li>Wenn die Gruppe verschiedene Unterkunftstyp nutzt (z.B. Zelt und Wohnmobil oder Wohnwagen), dann reservieren Sie für jede Unterkunftstyp separat und geben Sie die Anzahl der Personen, nach Alter, wie im Buchungsformular angegeben, und den Zeitraum der Unterkunft an Geben Sie an, wer diese Unterkunftsart nutzen wird, und tragen Sie die zusätzlichen Informationen und Dienstleistungen ein, die Sie benötigen (Stromanschluss usw.). Machen Sie dasselbe für die restlichen Reservierungen.<br />Wenn Sie möchten, dass wir solche Reservierungen als Reservierungen mehrerer Beförderer (Vorauszahler) betrachten, geben Sie vor Abschluss der Reservierung in der Notiz die anderen Beförderer sowie die Unterkunftstyp und die Anzahl der Personen bei jedem Beförderer an.<br /><br /></li><li>Bei Unklarheiten teilen Sie uns bitte Ihre Wünsche unter der E-Mail-Adresse <a href='mailto:booking@camp-liza.com'>booking@camp-liza.com</a> mit und wir senden Ihnen eine Antwort auf Ihre Anfrage.</li></ol>"
	},
	"fe__main_selector__accommodation_type": {
		"sl": "Vrsta namestitve",
		"en": "Accomodation type",
		"de": "Unterkunftstyp"
	},
	"fe__main_selector__person_count": {
		"sl": "Število oseb",
		"en": "Number of persons",
		"de": "Personenzahl"
	},
	"fe__main_selector__person_adult": {
		"sl": "Odrasli (14+)",
		"en": "Adults (14+)",
		"de": "Erwachsene (14+)"
	},
	"fe__main_selector__person_child_2": {
		"sl": "Otroci (7-14)",
		"en": "Children (7-14)",
		"de": "Kinder (7-14)"
	},
	"fe__main_selector__person_child_1": {
		"sl": "Otroci (0-7)",
		"en": "Children (0-7)",
		"de": "Kinder (0-7)"
	},
	"fe__main_selector__date_range": {
		"sl": "Obdobje",
		"en": "Period",
		"de": "Zeitraum"
	},
	"fe__main_selector__date_range_empty": {
		"sl": "Izberite obdobje",
		"en": "Choose a period",
		"de": "Zeitraum wählen"
	},
	"fe__bottom_bar__current_selection": {
		"sl": "Trenutni izbor",
		"en": "Current selection",
		"de": "Aktuelle Auswahl"
	},
	"fe__bottom_bar__cart__person_count": {
		"sl": "Število oseb:",
		"en": "Number of persons:",
		"de": "Personenzahl:"
	},
	"fe__bottom_bar__continue": {
		"sl": "NAPREJ",
		"en": "NEXT",
		"de": "WEITER"
	},
	"fe__bottom_bar__continue_index_text": {
		"sl": "Dodajte namestitev oz. pritisnite NAPREJ za nadaljevanje",
		"en": "Add additional accomodation or press NEXT to continue",
		"de": "Fügen Sie zusätzliche Unterkünfte hinzu oder drücken Sie WEITER, um fortzufahren"
	},
	"fe__overview__title": {
		"sl": "POVZETEK REZERVACIJE - Rezervacija na povpraševanje",
		"en": "RESERVATION SUMMARY - Reservation on request",
		"de": "ZUSAMMENFASSUNG DER RESERVIERUNG – Reservierung auf Anfrage"
	},
	"fe__overview__intro": {
		"sl": "To rezervacijo mora ponudnik storitev potrditi v 36 urah. Če ne prejmete potrditve oz. v primeru negativnega odgovora, rezervacija ni mogoča.",
		"en": "This reservation has to be confirmed by the service provider within 36 hours. If you receive no confirmation or a negative answer, the booking was not possible.",
		"de": "Diese Reservierung muss vom Leistungsträger innerhalb von 36 Stunden bestätigt werden. Sollten Sie keine Bestätigung oder eine negative Antwort erhalten, war die Buchung nicht möglich."
	},
	"fe__overview__table__service": {
		"sl": "Storitev",
		"en": "Service",
		"de": "Service"
	},
	"fe__overview__table__date_range": {
		"sl": "Obdobje",
		"en": "Period",
		"de": "Zeitraum"
	},
	"fe__overview__table__day_count": {
		"sl": "Dnevi",
		"en": "Days",
		"de": "Tage"
	},
	"fe__overview__table__quantity": {
		"sl": "Kol.",
		"en": "Qty",
		"de": "Menge"
	},
	"fe__overview__table__price_item": {
		"sl": "Cena",
		"en": "Price",
		"de": "Preis"
	},
	"fe__overview__table__price": {
		"sl": "Znesek",
		"en": "Amount",
		"de": "Betrag"
	},
	"fe__overview__table__total": {
		"sl": "Znesek rezervacije",
		"en": "Reservation Amount",
		"de": "Reservierungsbetrag"
	},
	"fe__overview__table__person_adult": {
		"sl": "Odrasli (14+)",
		"en": "Adults (14+)",
		"de": "Erwachsene (14+)"
	},
	"fe__overview__table__person_child_2": {
		"sl": "Otroci (7-14)",
		"en": "Children (7-14)",
		"de": "Kinder (7-14)"
	},
	"fe__overview__table__person_child_1": {
		"sl": "Otroci (0-7)",
		"en": "Children (0-7)",
		"de": "Kinder (0-7)"
	},
	"fe__overview__table__days": {
		"sl": "dan/dni",
		"en": "day/days",
		"de": "tag/tage"
	},
	"fe__overview__table__surcharge_d1": {
		"sl": "Doplačilo za 1 nočitev - Glamping hiška / Soba",
		"en": "Surcharge for 1 night - Glamping house / Room",
		"de": "Aufpreis für 1 Nacht - Glamping häuschen / Zimmer"
	},
	"fe__overview__table__surcharge_d2": {
		"sl": "Doplačilo za 2 nočitvi - Glamping hiška / Soba",
		"en": "Surcharge for 2 nights - Glamping house / Room",
		"de": "Aufpreis für 2 Nächte - Glamping häuschen / Zimmer"
	},
	"fe__overview__tourist_tax": {
		"sl": "Turistična taksa (odrasli 2,00€, otroci(7-18) 1,00€ na osebo/noč) ni vključena v ceni in se plača ob odhodu na recepciji.",
		"en": "Tourist tax (Adults 2,00€, Children(7-18) 1,00€ per person/night) is not included in the price and shall be paid at the reception upon departure.",
		"de": "Die Kurtaxe (Erwachsene 2,00€, Kinder(7-18) 1,00€ pro person/nacht) ist nicht im Preis inbegriffen und bei der Abreise an der Rezeption zu entrichten."
	},
	"fe__overview__prepayment_title": {
		"sl": "Potrebno predplačilo (30%)",
		"en": "Prepayment amount (30%)",
		"de": "Vorauszahlung (30%)"
	},
	"fe__overview__prepayment_description": {
		"sl": "Za potrditev rezervacije je potrebno predplačilo v višini 30 % zneska rezervacije.<br \/>\nPodrobnosti o podatkih za nakazilo boste prejeli po zaključku rezervacije, v ločenem e-mailu sporočilu s strani ponudnika.<br \/>Končno plačilo se poravna neposredno pri ponudniku ob odhodu.<br \/><br \/>\n<strong>Odpoved rezervacije<\/strong><br \/>Rezervacijo se lahko brezplačno odpove do 14 dni pred predvidenim terminom prihoda, ki je naveden v potrditvi rezervacije.",
		"en": "A prepayment of 30% of the reservation amount is required to confirm the reservation.\n<br \/>\n\nYou will receive transfer details after the reservation has been completed, in a separate e-mail message from the provider.\n\n<br \/>\nThe final payment is settled directly with the provider upon departure.\n\n<br \/><br \/>\n<strong>Cancellation of reservation<\/strong>\n<br \/>\nThe reservation can be canceled free of charge up to 14 days before the expected date of arrival, which is stated in the reservation confirmation.",
		"de": "Zur Bestätigung der Reservierung ist eine Vorauszahlung von 30 % des Reservierungsbetrags erforderlich.\n\n<br \/>\nEinzelheiten zu den Übertragungsdetails erhalten Sie nach Abschluss der Reservierung in einer separaten E-Mail-Nachricht des Anbieters.\n\n<br \/>\nDie Restzahlung erfolgt direkt bei der Abreise mit dem Anbieter.\n\n<br \/><br \/>\n<strong>Stornierung der Reservierung<\/strong>\n<br \/>\nDie Reservierung ist bis 14 Tage vor dem voraussichtlichen Anreisetermin, der in der Reservierungsbestätigung angegeben ist, kostenfrei stornierbar."
	},
	"fe__overview__customer__title": {
		"sl": "Podatki o nosilcu rezervacije",
		"en": "Booking information",
		"de": "Buchungsinformation"
	},
	"fe__overview__customer__name": {
		"sl": "Ime",
		"en": "Name",
		"de": "Name"
	},
	"fe__overview__customer__surname": {
		"sl": "Priimek",
		"en": "Surname",
		"de": "Nachname"
	},
	"fe__overview__customer__email": {
		"sl": "E-naslov",
		"en": "E-mail",
		"de": "E-mail"
	},
	"fe__overview__customer__email_again": {
		"sl": "Ponovi e-naslov",
		"en": "Confirm E-mail",
		"de": "E-Mail bestätigen"
	},
	"fe__overview__customer__country": {
		"sl": "Država",
		"en": "Country",
		"de": "Land"
	},
	"fe__overview__customer__phone": {
		"sl": "Telefonska številka",
		"en": "Phone Number",
		"de": "Telefonnummer"
	},
	"fe__overview__customer__address": {
		"sl": "Naslov",
		"en": "Address",
		"de": "Adresse"
	},
	"fe__overview__customer__post_office": {
		"sl": "Poštna številka in pošta",
		"en": "Post Code and post",
		"de": "Postleitzahl und Postamt"
	},
	"fe__overview__customer__note": {
		"sl": "Vaše sporočilo\n<br \/>\n<em>Vnesite opombo oz. komentar glede vaše rezervacije<\/em>",
		"en": "Your message\n<br \/>\n<em>Enter a note or a comment about your reservation<\/em>",
		"de": "Ihre Nachricht\n<br \/>\n<em>Geben Sie eine Notiz ein oder einen Kommentar zu Ihrer Reservierung<\/em>"
	},
	"fe__overview__customer__agree_1": {
		"sl": "Z oddajo rezervacije sprejemam pogoje poslovanja, ki so na voljo na spletni strani <a href='https:\/\/www.camp-liza.com\/pogoji-poslovanja\/' target='_blank'>https:\/\/www.camp-liza.com\/pogoji-poslovanja\/<\/a>",
		"en": "By submitting the reservation, I accept the terms and conditions available on the website <a href='https:\/\/www.camp-liza.com\/en\/terms-conditions\/' target='_blank'>https:\/\/www.camp-liza.com\/en\/terms-conditions\/<\/a>",
		"de": "Mit dem Absenden einer Reservierung akzeptiere ich die auf der Website <a href='https:\/\/www.camp-liza.com\/de\/agb\/' target='_blank'>https:\/\/www.camp-liza.com\/de\/agb\/<\/a> verfügbaren Geschäftsbedingungen."
	},
	"fe__overview__customer__agree_2": {
		"sl": "Strinjam se, da se moje kontaktne informacije hranijo in uporabljajo za obveščanje o novicah in drugih informacijah po e-pošti\/telefonu",
		"en": "I agree that my contact information is being stored and used to inform me about news and other information via e-mail\/phone.",
		"de": "Ich bin damit einverstanden, dass meine Kontaktinformationen gespeichert und verwendet werden, um mich per E-Mail\/Telefon über Neuigkeiten und andere Informationen zu informieren."
	},
	"fe__bottom_bar__back": {
		"sl": "NAZAJ NA IZBOR",
		"en": "BACK TO SELECTION",
		"de": "ZURUCK ZU AUSWAHL"
	},
	"fe__bottom_bar__confirm": {
		"sl": "POTRDI REZERVACIJO Z OBVEZNOSTJO PLAČILA",
		"en": "CONFIRM RESERVATION WITH PAYMENT OBLIGATION",
		"de": "RESERVIERUNG MIT ZAHLUNGSVERPFLICHTUNG BESTÄTIGEN"
	},
	"fe__success_dialog__title": {
		"sl": "<strong>Rezervacija je bila uspešno oddana.</strong><br /><br />Na e-mail naslov, ki ste ga posredovali, smo vam poslali povzetek rezervacije na povpraševanje.",
		"en": "<strong>The reservation was successfully submitted.</strong><br /><br />We have sent you a Reservation on request summary to the e-mail address you provided.",
		"de": "<strong>Die Reservierung wurde erfolgreich übermittelt.</strong><br /><br />Wir haben Ihnen eine Zusammenfassung der Reservierung auf Anfrage an die von Ihnen angegebene E-Mail-Adresse gesendet."
	},
	"fe__success_dialog__close": {
		"sl": "ZAPRI",
		"en": "CLOSE",
		"de": "SCHLIESSEN"
	},
	"fe__error_dialog__title": {
		"sl": "Opozorilo",
		"en": "Warning",
		"de": "Warnung"
	},
	"fe__error_dialog__validation_messages__empty_cart": {
		"sl": "Izbrati je potrebno vsaj eno rezervacijo!",
		"en": "You must select at least one reservation!",
		"de": "Sie müssen mindestens eine Reservierung auswählen!"
	},
	"fe__error_dialog__validation_messages__required_fields": {
		"sl": "Podatki o nosilcu rezervacije - Vsa polja morajo biti izpolnjena!",
		"en": "Booking information - All fields must be filled in!",
		"de": "Buchungsinformation - Alle Felder müssen ausgefüllt werden!"
	},
	"fe__error_dialog__validation_messages__invalid_email": {
		"sl": "Neveljaven e-naslov!",
		"en": "Invalid e-mail address!",
		"de": "Ungültige E-Mail-Adresse!"
	},
	"fe__error_dialog__validation_messages__emails_not_match": {
		"sl": "E-naslova se ne ujemata!",
		"en": "E-mail addresses do not match!",
		"de": "E-Mail-Adressen stimmen nicht überein!"
	},
	"fe__error_dialog__error_from_server": {
		"sl": "Napaka pri shranjevanju",
		"en": "Error while saving",
		"de": "Fehler beim Speichern"
	},
	"fe__error_dialog__occupied": {
		"sl": "Spodaj navedene rezervacije trenutno niso možne.<br />{reservations}<br /><br />Prosimo poizkusite ponovno in po potrebi spremenite pogoje iskanja.",
		"en": "The reservations listed below are currently not possible.<br />{reservations}<br /><br />Please try again and change the search conditions if necessary.",
		"de": "Die unten aufgeführten Reservierungen sind derzeit nicht möglich.<br />{reservations}<br /><br />Bitte versuchen Sie es erneut und ändern Sie gegebenenfalls die Suchbedingungen.",
	},
	"fe__error_dialog__close": {
		"sl": "ZAPRI",
		"en": "CLOSE",
		"de": "SCHLIESSEN"
	},
	"fe__accommodation_type__camp": {
		"sl": "Kampirno mesto",
		"en": "Camping pitch",
		"de": "Camping stellplatz"
	},
	"fe__accommodation_type__glamping": {
		"sl": "Glamping hiške",
		"en": "Glamping houses",
		"de": "Glamping-Häuschen"
	},
	"fe__accommodation_type__room": {
		"sl": "Sobe",
		"en": "Rooms",
		"de": "Zimmer"
	},
	"fe__accommodation_room__title": {
		"sl": "Sobe",
		"en": "Rooms",
		"de": "Zimmer"
	},
	"fe__accommodation_room__description_1": {
		"sl": "<li>V primeru, da vas na dan prihoda ni (no-show) se vaša rezervacija stornira.<\/li>\n\t\t\t\t<li>Check-in:  <strong>16:00-20:00.<\/strong><\/li>\n\t\t\t\t<li>Check-out: <strong>9:00-11:00.<\/strong><\/li>\n\t\t\t\t<li>Zajtrk ni vključen v ceno sobe.<\/li>\n\t\t\t\t<li>Prepovedano je kajenje v vseh prostorih.<\/li>\n\t\t\t\t<li>Domačih živali ne sprejemamo.<\/li>",
		"en": "<li>If you do not present yourself on the day of arrival (no-show), your reservation is canceled automatically.<\/li>\n <li>Check-in:  <strong>16:00-20:00.<\/strong><\/li>\n <li>Check-out: <strong>9:00-11:00.<\/strong><\/li>\n <li>Breakfast not included in the room rate.<\/li>\n <li>Smoking prohibited in all rooms.<\/li>\n <li>Pets are not allowed.<\/li>",
		"de": "<li>Für den Fall, dass Sie am Ankunftstag nicht erscheinen (no-show), wird Ihre Buchung storniert.<\/li>\n <li>Check-in:  <strong>16:00-20:00.<\/strong><\/li>\n <li>Check-out: <strong>9:00-11:00.<\/strong><\/li>\n <li>Ihr Frühstück ist im Preis nicht inbegriffen.<\/li>\n <li>Rauchen ist in allen Zimmern verboten.<\/li>\n <li>Haustiere werden nicht aufgenohmen.<\/li>"
	},
	"fe__accommodation_room__description_2": {
		"sl": "<li>Nimamo možnosti za dodatna ležišča, razen otroške posteljice.<\/li>\n\t\t\t\t<li>Pogoji poslovanja so na voljo na spletnem naslovu <a href='https:\/\/www.camp-liza.com\/pogoji-poslovanja\/' target='_blank'>https:\/\/www.camp-liza.com\/pogoji-poslovanja\/<\/a><\/li>\n\t\t\t\t<li>V primeru kršitve pogojev poslovanja si pridržujemo pravico do stornacije rezervacije.<\/li>\n\t\t\t\t<li>Sprejemamo plačilo z gotovino ali kreditno kartico.<\/li>\n\t\t\t\t<li>Pridržujemo si pravico do sprememb cen brez vnaprejšnje najave.<\/li>",
		"en": "<li>No extra beds available, except for cots.<\/li>\n<li>For Terms and Conditions please visit <a href='https:\/\/www.camp-liza.com\/pogoji-poslovanja\/en\/terms-conditions\/' target='_blank'>https:\/\/www.camp-liza.com\/en\/terms-conditions\/<\/a><\/li>\n<li>In case of violation of conditions your reservation will be canceled.<\/li>\n<li>We accept cash or credit cards.<\/li>\n<li>We reserve the right to change prices without prior notice.<\/li>",
		"de": "<li>Keine Möglichkeit für Zusatzbetten vorhanden, außer für ein Baby Bett.<\/li>\n<li>Für die Allgemeinen Geschäftsbedingungen sehen Sie <a href='https:\/\/www.camp-liza.com\/de\/agb\/' target='_blank'>https:\/\/www.camp-liza.com\/de\/agb\/<\/a><\/li>\n<li>Im Falle einer Verletzung der Bedingungen behalten wir uns das Recht, die Buchung zu stornieren.<\/li>\n<li>Gerne akzeptieren wir Kreditkarte oder Bargeld.<\/li>\n<li>Wir behalten uns das Recht vor, die Preise ohne vorherige Ankündigung zu ändern.<\/li>"
	},
	"fe__accommodation_room__show_more": {
		"sl": "Prikaži več",
		"en": "Show more",
		"de": "Zeig mehr"
	},
	"fe__accommodation_room__show_less": {
		"sl": "Prikaži manj",
		"en": "Show less",
		"de": "Zeige weniger"
	},
	"fe__accommodation_glamping__title": {
		"sl": "Glamping hiške",
		"en": "Glamping houses",
		"de": "Glamping-Häuschen"
	},
	"fe__accommodation_glamping__description_1": {
		"sl": "<li>V primeru, da vas na dan prihoda ni (no-show) se vaša rezervacija stornira.<\/li>\n\t\t\t\t<li>Check-in:  <strong>16:00-20:00.<\/strong><\/li>\n\t\t\t\t<li>Check-out: <strong>9:00-11:00.<\/strong><\/li>\n\t\t\t\t<li>Zajtrk ni vključen v ceno sobe.<\/li>\n\t\t\t\t<li>Prepovedano je kajenje v vseh prostorih.<\/li>\n\t\t\t\t<li>Domačih živali ne sprejemamo.<\/li>",
		"en": "<li>If you do not present yourself on the day of arrival (no-show), your reservation is canceled automatically.<\/li>\n <li>Check-in:  <strong>16:00-20:00.<\/strong><\/li>\n <li>Check-out: <strong>9:00-11:00.<\/strong><\/li>\n <li>Breakfast not included in the room rate.<\/li>\n <li>Smoking prohibited in all rooms.<\/li>\n <li>Pets are not allowed.<\/li>",
		"de": "<li>Für den Fall, dass Sie am Ankunftstag nicht erscheinen (no-show), wird Ihre Buchung storniert.<\/li>\n <li>Check-in:  <strong>16:00-20:00.<\/strong><\/li>\n <li>Check-out: <strong>9:00-11:00.<\/strong><\/li>\n <li>Ihr Frühstück ist im Preis nicht inbegriffen.<\/li>\n <li>Rauchen ist in allen Zimmern verboten.<\/li>\n <li>Haustiere werden nicht aufgenohmen.<\/li>"
	},
	"fe__accommodation_glamping__description_2": {
		"sl": "<li>Nimamo možnosti za dodatna ležišča, razen otroške posteljice.<\/li>\n\t\t\t\t<li>Pogoji poslovanja so na voljo na spletnem naslovu <a href='https:\/\/www.camp-liza.com\/pogoji-poslovanja\/' target='_blank'>https:\/\/www.camp-liza.com\/pogoji-poslovanja\/<\/a><\/li>\n\t\t\t\t<li>V primeru kršitve pogojev poslovanja si pridržujemo pravico do stornacije rezervacije.<\/li>\n\t\t\t\t<li>Sprejemamo plačilo z gotovino ali kreditno kartico.<\/li>\n\t\t\t\t<li>Pridržujemo si pravico do sprememb cen brez vnaprejšnje najave.<\/li>",
		"en": "<li>No extra beds available, except for cots.<\/li>\n<li> For Terms and Conditions please visit <a href='https:\/\/www.camp-liza.com\/pogoji-poslovanja\/en\/terms-conditions\/' target='_blank'>https:\/\/www.camp-liza.com\/en\/terms-conditions\/<\/a><\/li>\n<li>In case of violation of conditions your reservation will be canceled.<\/li>\n<li>We accept cash or credit cards.<\/li>\n<li>We reserve the right to change prices without prior notice.<\/li>",
		"de": "<li>Keine Möglichkeit für Zusatzbetten vorhanden, außer für ein Baby Bett.<\/li>\n<li>Für die Allgemeinen Geschäftsbedingungen sehen Sie <a href='https:\/\/www.camp-liza.com\/de\/agb\/' target='_blank'>https:\/\/www.camp-liza.com\/de\/agb\/<\/a><\/li>\n<li>Im Falle einer Verletzung der Bedingungen behalten wir uns das Recht, die Buchung zu stornieren.<\/li>\n<li>Gerne akzeptieren wir Kreditkarte oder Bargeld.<\/li>\n<li>Wir behalten uns das Recht vor, die Preise ohne vorherige Ankündigung zu ändern.<\/li>"
	},
	"fe__accommodation_glamping__show_more": {
		"sl": "Prikaži več",
		"en": "Show more",
		"de": "Zeig mehr"
	},
	"fe__accommodation_glamping__show_less": {
		"sl": "Prikaži manj",
		"en": "Show less",
		"de": "Zeige weniger"
	},
	"fe__accommodation_camp__title": {
		"sl": "Kampirna mesta",
		"en": "Camping pitches",
		"de": "Camping stellplätze"
	},
	"fe__accommodation_camp__intro": {
		"sl": "Cenjeni gostje, z rezervacijo kampirnega mesta v našem kampu vam kljub skrbnemu načrtovanju prostora in maksimalnemu upoštevanju vaših želja, žal ne moremo vedno zagotoviti izbranega kampirnega mesta.\n\t\t\t\t<br \/>\n\t\t\t\tVedno se bomo trudili, da boste bivali na mestu, ki si ga boste želeli, vas pa prosimo za razumevanje, če to ne bo vedno mogoće in si pridržujemo pravico zamenjave ter dodelitve druge kampirnega mesta.",
		"en": "Dear guests, despite our careful space planning and greatest consideration of your wishes, it may sometimes happen that we are, regrettably, unable to provide you with the pitch you have chosen with your booking.\n<br \/>\nWe are always trying our best to make sure you stay at your desired place. However, we kindly ask for your understanding when this is not possible and therefore reserve the right to offer you a different camping pitch in this case. Thank you for your understanding.",
		"de": "Liebe Gäste, trotz unserer sorgfältigen Raumplanung und maximalen Berücksichtigung von Ihren Wünschen kann es bedauerlicherweise ja mal passieren, dass wir den je nach Ihrer Buchung ausgewählten Stellplatz nicht für Sie sicherstellen können.\n<br \/>\nWir versuchen immer, Ihren gewünschten Platz Ihnen zur Verfügung zu stellen. Zugleich bitten wir Sie aber freundlicherweise um Verständnis, wenn dies nicht möglich wäre und behalten uns somit das Recht vor, Ihnen einen anderen Stellplatz anzubieten. Vielen Dank für Ihr Verständnis."
	},
	"fe__accommodation_camp__description_1": {
		"sl": "<li>V primeru, da vas na dan prihoda ni (no-show) se vaša rezervacija stornira.<\/li>\n\t\t\t\t<li>Check-in:  <strong>12:00-20:00.<\/strong><\/li>\n\t\t\t\t<li>Check-out: <strong>9:00-12:00.<\/strong><\/li>\n\t\t\t\t<li>Zajtrk ni vključen v ceno nočitve kampiranja.<\/li>\n\t\t\t\t<li>Pogoji poslovanja so na voljo na spletnem naslovu <a href='https:\/\/www.camp-liza.com\/pogoji-poslovanja\/' target='_blank'>https:\/\/www.camp-liza.com\/pogoji-poslovanja\/<\/a><\/li>\n\t\t\t\t<li>V primeru kršitve pogojev poslovanja si pridržujemo pravico do stornacije rezervacije.<\/li>",
		"en": "<li>If you do not present yourself on the day of arrival (no-show), your reservation is canceled automatically.<\/li>\n<li>Check-in:  <strong>12:00-20:00.<\/strong><\/li>\n<li>Check-out: <strong>9:00-12:00.<\/strong><\/li>\n<li>Breakfast not included in the camping pitch price.<\/li>\n<li>For Terms and Conditions please visit <a href='https:\/\/www.camp-liza.com\/en\/terms-conditions\/' target='_blank'>https:\/\/www.camp-liza.com\/en\/terms-conditions\/<\/a><\/li>\n<li>In case of violation of conditions your reservation will be canceled.<\/li>",
		"de": "<li>Für den Fall, dass Sie am Ankunftstag nicht erscheinen (no-show), wird Ihre Buchung storniert.<\/li>\n<li>Check-in:  <strong>12:00-20:00.<\/strong><\/li>\n    <li>Check-out: <strong>9:00-12:00.<\/strong><\/li>\n<li>Ihr Frühstück ist im Camping Stellplatz Preis nicht inbegriffen.<\/li>\n<li>Für die Allgemeinen Geschäftsbedingungen sehen Sie <a href='https:\/\/www.camp-liza.com\/de\/agb\/' target='_blank'>https:\/\/www.camp-liza.com\/de\/agb\/<\/a><\/li>\n<li>Im Falle einer Verletzung der Bedingungen behalten wir uns das Recht, die Buchung zu stornieren.<\/li>"
	},
	"fe__accommodation_camp__description_2": {
		"sl": "<li>Sprejemamo plačilo z gotovino ali kreditno kartico.<\/li>\n\t\t\t\t<li>Pridržujemo si pravico do sprememb cen brez vnaprejšnje najave.<\/li>",
		"en": "<li>We accept cash or credit cards.<\/li>\n<li>We reserve the right to change prices without prior notice.<\/li>",
		"de": "<li>Gerne akzeptieren wir Kreditkarte oder Bargeld.<\/li>\n<li>Wir behalten uns das Recht vor, die Preise ohne vorherige Ankündigung zu ändern.<\/li>"
	},
	"fe__accommodation_camp__show_more": {
		"sl": "Prikaži več",
		"en": "Show more",
		"de": "Zeig mehr"
	},
	"fe__accommodation_camp__show_less": {
		"sl": "Prikaži manj",
		"en": "Show less",
		"de": "Zeige weniger"
	},
	"fe__accommodation_item__choose": {
		"sl": "IZBERI",
		"en": "CHOOSE",
		"de": "WÄHLEN"
	},
	"fe__accommodation_item__occupied": {
		"sl": "NI NA VOLJO",
		"en": "UNAVAILABLE",
		"de": "NICHT VERFÜGBAR"
	},
	"fe__accommodation_item__in_cart": {
		"sl": "TRENUTNO IZBRANO",
		"en": "CURRENTLY SELECTED",
		"de": "MOMENTAN AUSGEWÄHLT"
	},
	"fe__accommodation_item__max_people_exceeded": {
		"sl": "OSEBE (MAX.): {count}",
		"en": "PERSONS (MAX.): {count}",
		"de": "PERSONEN (MAX.): {count}"
	},
	"fe__accommodation_details_dialog__title": {
		"sl": "Potrebujemo še nekaj informacij, da vam lahko ponudimo najprimernejše kampirno mesto",
		"en": "We need some more information to offer you the most suitable camping pitch",
		"de": "Wir benötigen noch einige weitere Informationen, um Ihnen den am besten geeigneten Campingplatz anbieten zu können"
	},
	"fe__accommodation_details_dialog__additional_services__title": {
		"sl": "Dodatne storitve (doplačilo)",
		"en": "Additional services (surcharge)",
		"de": "Zusatzleistungen (Aufpreis)"
	},
	"fe__accommodation_details_dialog__cancel": {
		"sl": "Prekliči",
		"en": "Cancel",
		"de": "Absagen"
	},
	"fe__accommodation_details_dialog__continue": {
		"sl": "Nadaljuj",
		"en": "Continue",
		"de": "Weitermachen"
	}
};
